import { DriverComment } from './constants';

export type DriverCommentApiResponse = {
  driverName: string;
  driverNumber: string;
  customerCode: string;
  notes: string;
  createdDateTime?: string;
};

export const buildDriverCommentsQueryString = ({
  terminalId,
  customerCode
}: {
  terminalId: string | number;
  customerCode: string;
}) =>
  `terminalId=${encodeURIComponent(terminalId)}&customerCode=${encodeURIComponent(customerCode)}`;

/** Adds rowId for AG Grid — API returns no unique comment id per row. */
export const normalizeDriverComments = (
  driverComments?: DriverCommentApiResponse[] | null
): DriverComment[] =>
  (driverComments ?? []).map((comment, index) => ({
    ...comment,
    rowId: `${comment.driverNumber}-${comment.createdDateTime ?? index}`
  }));
